/**
 * SECTION_CATEGORIES — sidebar list for the Add Section modal.
 *
 * Order matches Squarespace's section library so the experience feels
 * familiar to vendors migrating from there. Groups:
 *   • Essentials — every site needs these
 *   • Showcase   — visual storytelling
 *   • Engage     — convert + connect
 *   • Premium    — high-conversion long-scroll templates
 */
export const SECTION_CATEGORIES = [
  // ── Essentials ──
  { id: 'introduce',            label: 'Introduction',     group: 'Essentials' },
  { id: 'about',                label: 'About',            group: 'Essentials' },
  { id: 'contact',              label: 'Contact',          group: 'Essentials' },
  { id: 'team',                 label: 'Team',             group: 'Essentials' },
  { id: 'footer',               label: 'Footers',          group: 'Essentials' },

  // ── Showcase ──
  { id: 'services',             label: 'Services',         group: 'Showcase' },
  { id: 'shop',                 label: 'Products',         group: 'Showcase' },
  { id: 'pricing',              label: 'Pricing',          group: 'Showcase' },
  { id: 'portfolio',            label: 'Portfolio',        group: 'Showcase' },
  { id: 'images',               label: 'Gallery',          group: 'Showcase' },
  { id: 'testimonials',         label: 'Testimonials',     group: 'Showcase' },
  { id: 'menus',                label: 'Menus',            group: 'Showcase' },
  { id: 'videos',               label: 'Videos',           group: 'Showcase' },

  // ── Engage ──
  { id: 'faq',                  label: 'FAQs',             group: 'Engage' },
  { id: 'scheduling',           label: 'Scheduling',       group: 'Engage' },
  { id: 'forms',                label: 'Forms',            group: 'Engage' },
  { id: 'newsletter',           label: 'Newsletter',       group: 'Engage' },
  { id: 'cta',                  label: 'CTA',              group: 'Engage' },
  { id: 'social',               label: 'Social Links',     group: 'Engage' },
  { id: 'donations',            label: 'Donations',        group: 'Engage' },
  { id: 'content-memberships',  label: 'Memberships',      group: 'Engage' },
  { id: 'group-events',         label: 'Events',           group: 'Engage' },
  { id: 'auth-account',         label: 'Sign Up / Login',  group: 'Engage' },

  // ── Premium ──
  { id: 'agency',               label: 'Service Business', group: 'Premium' },
];
